(function () {
'use strict';

angular
    .module('itPurchasingControllers')
    .directive('itPurchasingSystemCard', directive);

directive.$inject = [];

function directive() {
    return {
        scope: {
            businessTasks: '=',
            isMultiSelect: '=',
            pendingSystemRoles: '=',
            selectedCard: '=',
            systemAndEmployee: '=',
            toSelectCard: '&',
        },
        restrict: 'AE',
        templateUrl: '/app/Main/itPurchasing/itPurchasingSystemCard.tpl.html',
        controller: ['$scope', 'ITPurchasingService', function ($scope, ITPurchasingService) {

            // Get pending system roles
            $scope.getPendingSystemRoles = function (systemAndEmployee) {
                var key = systemAndEmployee.SystemID + '|' + systemAndEmployee.UserAccessRequestID;
                return $scope.pendingSystemRoles[key];
            };
    
            // Get card classes
            $scope.getCardClasses = function (systemAndEmployee) {
                var cssClasses = systemAndEmployee.StatusCssBorderClass;

                if ($scope.isMultiSelect) {
                    return cssClasses + ' well-multi-select';
                }

                cssClasses += ' well-toProcess';

                if ($scope.selectedCard !== systemAndEmployee) {
                    return cssClasses;
                }

                return cssClasses + ' well-blue';
            };

            // Select card
            $scope.selectCard = function (systemAndEmployee) {
                if ($scope.isMultiSelect) { return; }

                $scope.toSelectCard(systemAndEmployee);
            };

            // Toggle Selection for multi select
            $scope.toggleSelectionForMultiSelect = function (systemAndEmployee, $event) {
                systemAndEmployee.isSelectedForMultiSelect = !systemAndEmployee.isSelectedForMultiSelect;
                $event.stopPropagation();
            };
            
            // Get Existing System Roles
            $scope.getExistingSystemRoles = function (systemAndEmployee) {
                ITPurchasingService.getExistingSystemRoles(systemAndEmployee)
                           .then(function (newContainer) {
                               for (var bySystem in newContainer.PendingSystemRoles) {
                                   var pendings = $scope.pendingSystemRoles[bySystem];

                                   $scope.existingSysRoles = _.filter(newContainer.PendingSystemRoles[bySystem], function (existingSysRole) {
                                       var exist = _.find(pendings, function (p) { return p.SystemRoleID === existingSysRole.SystemRoleID; });
                                       return exist.length == 0;
                                   });
                               }
                           });
            };

            // Get all business tasks
            $scope.getAllBusinessTasks = function (systemAndEmployee) {
                return _.chain($scope.getPendingSystemRoles(systemAndEmployee))
                        .map(function (pending) {
                            return $scope.businessTasks[pending.SystemRoleID];
                        })
                        .filter(function (tasks) {
                            return !_.isUndefined(tasks);
                        })
                        .flatten()
                        .map(function (task) {
                            return {
                                'Name': task.Name,
                                'BusinessActivityName': task.BusinessActivityName,
                                'BusinessProcessName': task.BusinessProcessName
                            };
                        })
                        .uniq()
                        .value();
            };
            
        }],
        link: function (scope, element, attrs) {
            // Existing system roles
            scope.existingSysRoles = scope.getExistingSystemRoles(scope.systemAndEmployee);

            // All business tasks
            scope.allBusinessTasks = scope.getAllBusinessTasks(scope.systemAndEmployee);
        }
    };
}
})();
